import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'logged-user',
    initialState: {
        codiceUtente: 'anonymous',
        username: 'anonymous',
        IsAuthenticated: false,
        statusAction: 'READY',
    },
    actions: ['GET_LOGGED_USER'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_LOGGED_USER_SUCCESS:
                return {
                    ...state,
                    username: action.payload.username,
                    codiceUtente: action.payload.codiceUtente,
                    IsAuthenticated: action.payload.IsAuthenticated,
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getLoggedUserRequest: () => ({ type: types.GET_LOGGED_USER_REQUEST }),
        getLoggedUserSuccess: ({ username, codiceUtente, IsAuthenticated }) => ({
            type: types.GET_LOGGED_USER_SUCCESS,
            payload: { username, codiceUtente, IsAuthenticated },
        }),
        getLoggedUserFailed: error => ({ type: types.GET_LOGGED_USER_FAILED, error: true, payload: { error } }),
    }),
});
